import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import { compose, withPropsOnChange, withHandlers } from 'recompose';
var enhancer = compose(withPropsOnChange(['application_id', 'current_application_id', 'current_application', 'applications_map'], function (_ref) {
  var application_id = _ref.application_id,
    applications_map = _ref.applications_map,
    current_application_id = _ref.current_application_id,
    current_application = _ref.current_application;
  return {
    // if user is trying to batch send note to current application, grab information from store as lazyload
    // prevents call from being made, else use the application_map that was created through retriving multiple applications
    application: application_id == current_application_id ? current_application : applications_map[application_id],
    mostRecentNoteAuthorType: applications_map[application_id] && applications_map[application_id].most_recent_note_author_type
  };
}), withPropsOnChange(['application'], function (_ref2) {
  var application = _ref2.application;
  var calculatedProps = {};
  if (application) {
    try {
      calculatedProps.program = application.program;
      calculatedProps.programName = application.program && application.program.name;
    } catch (e) {
      console.error(e, 'cannot get program inside application', application);
    }
    try {
      calculatedProps.school = application.program && application.program.school || application.school;
      calculatedProps.schoolName = application.program && application.program.school && application.program.school.name || application.school && application.school.name;
    } catch (e) {
      console.error(e, 'cannot get school inside application', application);
    }
    try {
      calculatedProps.student = application.student;
      calculatedProps.studentName = [application.student && application.student.first_name || application.student && application.student.personal_information && application.student.personal_information.first_name, application.student && application.student.middle_name || application.student && application.student.personal_information && application.student.personal_information.middle_name, application.student && application.student.last_name || application.student && application.student.personal_information && application.student.personal_information.last_name].filter(function (e) {
        return !!e;
      }).join(' ');
    } catch (e) {
      console.error(e, 'cannot get student inside application', application);
    }
  }
  return calculatedProps;
}), withHandlers({
  handleRemove: function handleRemove(_ref3) {
    var application_id = _ref3.application_id,
      onRemove = _ref3.onRemove;
    return function () {
      return onRemove(application_id);
    };
  }
}));
export default enhancer;